import { useEffect, useState, useContext } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";

import Header from "../Header";
import useLocalStorage from "../../hooks/useLocalStorage";
import { ModalContext } from "../../context";
import settings from "../../config";

const FabricCuts = () => {
  const [fabricTransactions, setFabricTransactions] = useState([]);
  const { fabricId } = useParams();
  const [admin] = useLocalStorage("admin");
  const [, setModal] = useContext(ModalContext);

  useEffect(() => {
    (async () => {
      const response = await axios.post(`${settings.api}fabric/transactions`, {
        fabricId,
        transactionType: -1,
      });

      if (response.data.statusCode === 200) {
        setFabricTransactions(response.data.data);
      }
    })();
  }, [fabricId]);

  const deleteFabricTransaction = async (fabricTransactionId) => {
    setModal({
      isModalOpen: true,
      modalAction: async () => {
        const response = await axios.post(
          `${settings.api}fabric/delete-transaction`,
          {
            fabricTransactionId,
          },
        );

        if (response.data.statusCode === 200) {
          setFabricTransactions(
            fabricTransactions.filter(
              (fabricTransaction) =>
                fabricTransactionId !== fabricTransaction.fabricTransactionId,
            ),
          );
        }
      },
    });
  };

  return (
    <div className="w-full" dir="rtl">
      <Header text="قص قماش" link={`/fabric/cut/form/${fabricId}`} />
      <table className="w-full table-auto text-right ">
        <thead>
          <tr>
            <th className="p-4">مسلسل</th>
            <th className="p-4">اسم خامه القماش</th>
            <th className="p-4">الوزن</th>
            <th className="p-4">تاريخ القص</th>
            <th className="p-4">الموسم</th>
            <th className="text-center w-24 p-4">تركيب</th>
            {admin.canEdit === 1 && (
              <th className="text-center w-24 p-4">تعديل</th>
            )}
            {admin.canDelete === 1 && (
              <th className="text-center w-24 p-4">حذف</th>
            )}
          </tr>
        </thead>
        <tbody>
          {fabricTransactions.map((fabricTransaction) => {
            return (
              <tr
                key={fabricTransaction.fabricTransactionId}
                className="odd:bg-secondaryBg"
              >
                <td className="p-4">{fabricTransaction.fabricTransactionId}</td>
                <td className="p-4">{fabricTransaction.fabricName}</td>
                <td className="p-4">
                  {(fabricTransaction.weight || 0).toLocaleString("en-US")}
                </td>
                <td className="p-4">{fabricTransaction.transactionDate}</td>
                <td className="p-4">{fabricTransaction.seasonName}</td>
                <td className="text-center p-4">
                  <Link
                    to={`/fabric/variants/${fabricTransaction.fabricTransactionId}`}
                    className="flex flex-col items-center w-full cursor-pointer"
                  >
                    👕
                  </Link>
                </td>
                {admin.canEdit === 1 && (
                  <td className="text-center p-4">
                    <Link
                      to={`/fabric/cut/form/${fabricId}/${fabricTransaction.fabricTransactionId}`}
                      className="flex flex-col items-center w-full cursor-pointer"
                    >
                      ✏
                    </Link>
                  </td>
                )}
                {admin.canDelete === 1 && (
                  <td className="text-center p-4">
                    <div
                      className="flex flex-col items-center w-full cursor-pointer"
                      onClick={() =>
                        deleteFabricTransaction(
                          fabricTransaction.fabricTransactionId,
                        )
                      }
                    >
                      ❌
                    </div>
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FabricCuts;
